var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1"},[_c('GmapMap',{ref:"routeMap",staticStyle:{"height":"100%"},attrs:{"center":_vm.route.terminals.origin,"zoom":10,"map-type-id":"roadmap","options":_vm.mapOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }